import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-left",
  "use": "icon-arrow-left-usage",
  "viewBox": "82.083 0 280.364 444.531",
  "content": "<symbol viewBox=\"82.083 0 280.364 444.531\" id=\"icon-arrow-left\">\r\n<path d=\"M213.13,222.409L351.88,83.653c7.05-7.043,10.567-15.657,10.567-25.841c0-10.183-3.519-18.793-10.567-25.835l-21.409-21.416\r\n\tC323.432,3.521,314.817,0,304.637,0c-10.18,0-18.791,3.521-25.841,10.561L92.649,196.425c-7.044,7.043-10.566,15.656-10.566,25.841\r\n\ts3.521,18.791,10.566,25.837l186.146,185.863c7.05,7.043,15.66,10.564,25.841,10.564c10.182,0,18.795-3.521,25.834-10.564\r\n\tl21.409-21.412c7.05-7.039,10.567-15.604,10.567-25.697c0-10.084-3.519-18.746-10.567-25.978L213.13,222.409z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./app/general/svg/arrow-left.svg
// module id = 51GQ
// module chunks = 0